import { Typography, Tooltip } from 'antd'
import styled from 'styled-components'

export const TagList = record => {
  const { resource_tag_list: resourceTagList } = record.data
  let shortestTagName = null // 用于存储最短的 tagName
  let firstTagCategoryName = null

  // 检查 resourceTagList 是否至少有一个元素
  if (resourceTagList?.length > 0) {
    // 获取第一个对象的 tagList
    let firstTagList = resourceTagList[0].tag_list
    firstTagCategoryName = resourceTagList[0].tag_category_name

    // 如果没有 tagList 或 tagList 为空，则不需要进行任何操作
    if (firstTagList && firstTagList?.length > 0) {
      // 初始化最小长度和对应的 tagName
      let minLength = Infinity
      firstTagList.forEach((item, index) => {
        if (item.tag_name.length < minLength) {
          minLength = item.tag_name.length
          shortestTagName = item.tag_name // 更新最短的 tagName
        }
      })
      firstTagList = firstTagList.filter(item => item.tag_name !== shortestTagName)

      // 更新 resourceTagList 中的第一个元素的 tagList
      resourceTagList[0].tag_list = firstTagList
    }
  }
  const leftCount = resourceTagList?.reduce(
    (count, category) => count + category.tag_list.length, // 直接累加每个tagList的长度
    0,
  )
  return (
    <>
      <TagListContainer>
        {firstTagCategoryName && shortestTagName && (
          <Typography.Text
            style={{
              maxWidth: 160,
              background: '#E0E6EA',
              borderRadius: '4px',
              padding: '0 4px',
              marginRight: '4px',
            }}
            ellipsis={{
              tooltip: {
                getPopupContainer: () => document.body,
                title: (
                  <div>
                    {firstTagCategoryName}-{shortestTagName}
                  </div>
                ),
              },
            }}
          >
            {firstTagCategoryName}-{shortestTagName}
          </Typography.Text>
        )}

        {leftCount > 0 && (
          <Tooltip
            getPopupContainer={() => document.body}
            overlayClassName="tagTooltip"
            overlayInnerStyle={{ flexDirection: 'column', alignItems: 'flex-start' }}
            title={resourceTagList?.map((item, index) => {
              const sortedTagList = (item.tag_list || []).sort((a, b) => {
                // 假设我们要按照 tagCategoryName-tagName 的字符串长度排序
                const strA = `${a.tag_name}`
                const strB = `${b.tag_name}`
                return strA?.length - strB?.length
              })
              return (
                <div key={index}>
                  {sortedTagList?.map((it, index2) => (
                    <div key={index2} style={{ marginTop: '5px', display: 'block' }}>
                      {item.tag_category_name}-{it.tag_name}
                    </div>
                  ))}
                </div>
              )
            })}
          >
            <Typography.Text
              style={{
                marginLeft: 4,
                height: '20px',
                background: '#E0E6EA',
                borderRadius: '4px',
                padding: '0 4px',
                flexShrink: 0,
              }}
            >
              +{leftCount}
            </Typography.Text>
          </Tooltip>
        )}
      </TagListContainer>
    </>
  )
}

const TagListContainer = styled.span`
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
